import { render } from "./InputPhone.vue?vue&type=template&id=36d72bd2"
import script from "./InputPhone.vue?vue&type=script&lang=js"
export * from "./InputPhone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__